import messages from './tag-messages.js';
export default [
    { tag: 'penguinmod', intlLabel: messages.penguinmod },
    { tag: 'other_mods', intlLabel: messages.other_mods },
    { tag: 'turbowarp', intlLabel: messages.turbowarp },
    { tag: 'scratch', intlLabel: messages.scratch },
    { tag: 'categoryexpansion', intlLabel: messages.categoryexpansion },
    { tag: 'programminglanguage', intlLabel: messages.programminglanguage },
    { tag: 'hardware', intlLabel: messages.categoryhardware },
    { tag: 'builders', intlLabel: messages.categorybuilders },
    { tag: 'ai', intlLabel: messages.categoryai },
];
